import { accountConfig } from "./accountConfig";
import { userConfig } from "./userConfig";

export const configs = {
  accounts: accountConfig,
  users: userConfig,
};
